import { useAppDispatch, useAppSelector } from "app/hooks";
import { Link as RouterLink } from "react-router-dom";
import { useForm } from "hooks/useForm";
import CenterContainer from "features/containers/CenterContainer";
import { requestReset, RequestResetData, selectError, selectLoading } from "./resetPasswordSlice";
import { Alert, Box, Button, Card, Link, TextField, Typography } from "@mui/material";

const ResetPasswordForm: React.FC = () => {
  const dispatch = useAppDispatch();
  const resetLoading = useAppSelector(selectLoading);
  const error = useAppSelector(selectError);

  // Using form hook for validation
  const {
    handleSubmit,
    handleChange,
    data: resetPasswordData,
    errors,
  } = useForm<RequestResetData>({
    validations: {
      email: {
        pattern: {
          value:
            /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
          message: "Ange en giltig epostadress.",
        },
      },
    },
    initialValues: {
      email: "",
    },
    onSubmit: () => {
      dispatch(requestReset(resetPasswordData));
    },
  });
  return (
    <CenterContainer>
      <Card elevation={8} sx={{ p: 4, borderRadius: "1rem" }}>
        <Typography variant="h1" fontSize="2rem" textAlign="center" mb={2}>
          Återställ lösenord
        </Typography>

        <Typography textAlign="center" mb={2}>
          Har du glömt ditt lösenord? Inga problem, ange din email så skickar vi en länk för att
          återställa det.
        </Typography>

        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ display: "grid", gap: 1 }}>
          <TextField
            variant="filled"
            value={resetPasswordData.email}
            onChange={handleChange("email")}
            type="email"
            placeholder="name@example.com"
            error={!!errors.email}
            helperText={errors.email}
            fullWidth
            label="E-post"
          />

          {/* Show server errors if present */}
          {error && Object.keys(errors).length < 1 && (
            <Alert severity="error">
              <Box className="m-0">{error}</Box>
            </Alert>
          )}

          <Button type="submit" variant="contained" loading={resetLoading} size="large">
            Skicka återställningslänk
          </Button>

          <Link component={RouterLink} to="/login" underline="hover" color="primary.dark">
            Till logga in
          </Link>
        </Box>
      </Card>
    </CenterContainer>
  );
};

export default ResetPasswordForm;
